import {
  Box,
  styled,
  Typography,
  Button,
} from "@mui/material"
import { colors } from "../../../theme/colors"

export const ContentContainer = styled(Box)({
  display: "flex",
  flexDirection: "column",
  flex: 1,
})

export const TopContainer = styled(Box)({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  textAlign: "center",
  marginTop: "20px",
  marginBottom: "0",
})

export const ScrollContainer = styled(Box)({
  display: "flex",
  flexDirection: "column",
  flex: 1,
  overflow: "auto",
})

export const CenterContainer = styled(Box)({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  marginTop: 10,
})

export const RecipientContainer = styled(Box)({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  marginTop: 10,
})

export const SourceDescription = styled(Typography)({
  color: colors.lightBlack,
  fontSize: 22,
  lineHeight: "24px",
  marginTop: 30,
  fontWeight: 500,
  width: 300
})

export const Amount = styled(Typography)({
  marginTop: 10,
  color: colors.lightBlack,
  fontSize: 42,
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  height: 72,
})



export const IconContainer = styled(Box)({
  width: "100%",
  display: "flex",
  justifyContent: "center",
  marginTop: "auto",
})

export const StyledButton = styled(Button)({
  marginTop: 10,
  minHeight: 54,
  width: "100%",
})

export const ButtonsContainer = styled(Box)({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  zIndex: 2,
  width: "100%",
  bottom: 0,
  left: 0,
})

export const ButtonTransfer = {
  display: "flex",
  flexDirection: "column",
}

export const ContinueButton = styled(Button)({
  marginTop: 10,
})